import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../Component/CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header>
      {/* 左侧固定侧边栏 */}
      <nav className="sidebar">
        <div className="sidebar-content">
          <h1 className="brand-logo">
            <Link to="/" onClick={toTop}>
              Margotal
            </Link>
          </h1>

          <ul className="main-menu">
            <li>
              <Link to="/shop" onClick={toTop}>
                SHOP
              </Link>
            </li>
          </ul>

          <ul className="footer-menu">
            <li>
              <Link to="/about" onClick={toTop}>
                ABOUT
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toTop}>
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      {/* 右上角工具栏 */}
      <div className="top-bar">
        <div className="top-bar-links">
          <Link to="/cartpage" className="cart-link">
            <span className="cart-icon">🛒</span>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
